import {useRef} from 'react';
import {SECTION_TYPES} from './section/SectionTypes';
import {useHistory} from 'react-router';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';

class ScrollService {
  history: ReturnType<typeof useHistory> | null = null;

  constructor(history: ReturnType<typeof useHistory>) {
    this.history = history;
  }

  scroll(type: SECTION_TYPES) {
    this.history?.push(`${DASHBOARD_ROUTES.MIDI}?section=${type}`);
  }
}

// react hook ref implementation
const useScrollService = () => {
  const history = useHistory();
  return useRef(new ScrollService(history));
};

export {ScrollService, useScrollService};
